
import { Component, Model, Prop, Vue, Watch } from 'vue-property-decorator';
import AutoDismissedError from '../services/AutoDismissedError';
import { getErrorMessages } from '../utils/getErrorMessage';

@Component({ components: {} })
export default class extends Vue {
  @Model('change', { type: [Error, Object, String], required: true })
  readonly error!: Error | string;

  @Prop({ type: [Boolean, Number], default: null }) readonly autoDismiss:
    | boolean
    | number
    | undefined
    | null;

  @Prop({ type: Number, default: 5000 }) readonly defaultTimeout!: number;

  timeout: number | undefined;

  isVisible = true;

  get value() {
    let value = this.autoDismiss;
    if (typeof this.error === 'string') {
      return value;
    }
    if ((value == null || value === true) && this.error) {
      if (this.error instanceof AutoDismissedError || 'timeout' in this.error) {
        value = (this.error as HashAny).timeout;
      } else if ('autoDismiss' in this.error) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        value = (this.error as any).autoDismiss as boolean | number;
      }
    }
    return value;
  }

  get isDismissable() {
    return this.value == null || this.value !== false;
  }

  get errorMessages(): string[] {
    const { error } = this;
    if (!error) {
      return [];
    }
    return getErrorMessages(error);
  }

  clear() {
    this.isVisible = false;
    this.$emit('change', null);
  }

  mounted() {
    const { value } = this;
    const timeout = typeof value === 'number' ? value : this.defaultTimeout;
    if (value) {
      this.timeout = setTimeout(() => this.clear(), timeout);
    }
  }

  beforeDestroy() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  @Watch('error')
  onErrorChanged() {
    this.isVisible = !!this.error;
  }
}
